module.exports = __webpack_public_path__ + "static/img/24-1.5f92ffe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/24-1.jpg
// module id = gMLf
// module chunks = 0